import React from 'react';
import { useNavigate } from 'react-router-dom';
import './LoginPromptModal.css';

export default function LoginPromptModal({ isOpen, onClose }) {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleGoToLogin = () => {
    onClose();
    navigate('/login');
  };

  return (
    <div className="lpm-modal-overlay" onClick={onClose}>
      <div className="lpm-modal-card" onClick={(e) => e.stopPropagation()}>
        <div className="lpm-modal-glow" />

        <div className="lpm-modal-content">
          {/* Lock Icon Badge */}
          <div className="lpm-icon-wrapper">
            <div className="lpm-icon-pulse" />
            <div className="lpm-icon">🔒</div>
          </div>

          <span className="lpm-modal-tag">Authentication Required</span>

          <h2 className="lpm-modal-title">Sign In to Enroll</h2>

          <p className="lpm-modal-message">
            You need to be logged into your <strong>AV Tech</strong> account to enroll in this program and track your learning progress.
          </p>

          <div className="lpm-modal-actions">
            <button className="lpm-modal-btn-primary" onClick={handleGoToLogin}>
              Proceed to Login
            </button>
            <button className="lpm-modal-btn-secondary" onClick={onClose}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}